import { render, staticRenderFns } from "./GetStudentInfo.vue?vue&type=template&id=eb3f8718&scoped=true"
import script from "./GetStudentInfo.vue?vue&type=script&lang=js"
export * from "./GetStudentInfo.vue?vue&type=script&lang=js"
import style0 from "./GetStudentInfo.vue?vue&type=style&index=0&id=eb3f8718&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3f8718",
  null
  
)

export default component.exports